import React from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ArcElement,
  PointElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import { FiUsers, FiTrendingUp, FiPieChart, FiCalendar } from "react-icons/fi";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  ArcElement,
  PointElement,
  Tooltip,
  Legend,
  Title
);

export default function Reports() {
  // Department Analytics
  const departmentAnalytics = {
    labels: ["IT", "HR", "Finance", "Marketing"],
    datasets: [
      {
        label: "Leaves",
        data: [12, 7, 5, 10],
        backgroundColor: "rgba(59, 130, 246, 0.7)",
      },
      {
        label: "Attendance",
        data: [18, 15, 20, 12],
        backgroundColor: "rgba(16, 185, 129, 0.7)",
      },
    ],
  };

  // Monthly Leave Trend
  const leaveTrend = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Leaves",
        data: [10, 12, 9, 14, 8, 11],
        borderColor: "#6366F1",
        backgroundColor: "#6366F144",
        tension: 0.4,
      },
    ],
  };

  // Gender Ratio
  const genderData = {
    labels: ["Male", "Female", "Other"],
    datasets: [
      {
        data: [30, 18, 2],
        backgroundColor: ["#3B82F6", "#EC4899", "#22C55E"],
      },
    ],
  };

  // Attendance Comparison
  const attendanceTrend = {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "Attendance %",
        data: [92, 88, 95, 90],
        borderColor: "#10B981",
        backgroundColor: "#10B98144",
        tension: 0.4,
      },
    ],
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen space-y-8">

        <h1 className="text-3xl font-bold text-gray-800">HR Reports & Analytics</h1>

        {/* 📌 Top Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <Card className="flex items-center gap-4 p-5 shadow-md bg-white">
            <FiUsers className="text-blue-600 text-4xl" />
            <div>
              <p className="text-sm text-gray-500">Total Employees</p>
              <p className="text-2xl font-bold text-gray-800">50</p>
            </div>
          </Card>

          <Card className="flex items-center gap-4 p-5 shadow-md bg-white">
            <FiCalendar className="text-green-600 text-4xl" />
            <div>
              <p className="text-sm text-gray-500">Leave Requests</p>
              <p className="text-2xl font-bold text-gray-800">34</p>
            </div>
          </Card>

          <Card className="flex items-center gap-4 p-5 shadow-md bg-white">
            <FiTrendingUp className="text-purple-600 text-4xl" />
            <div>
              <p className="text-sm text-gray-500">Avg Attendance</p>
              <p className="text-2xl font-bold text-gray-800">92%</p>
            </div>
          </Card>

          <Card className="flex items-center gap-4 p-5 shadow-md bg-white">
            <FiPieChart className="text-pink-600 text-4xl" />
            <div>
              <p className="text-sm text-gray-500">Active Departments</p>
              <p className="text-2xl font-bold text-gray-800">4</p>
            </div>
          </Card>
        </div>

        {/* 📊 Charts Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Department Analytics */}
          <Card>
            <h2 className="text-xl font-semibold mb-4">Department Analytics</h2>
            <Bar data={departmentAnalytics} />
          </Card>

          {/* Leave Trend */}
          <Card>
            <h2 className="text-xl font-semibold mb-4">Monthly Leave Trend</h2>
            <Line data={leaveTrend} />
          </Card>
        </div>

        {/* 📈 Second Row of Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* Attendance Trend */}
          <Card>
            <h2 className="text-xl font-semibold mb-4">Attendance Trend</h2>
            <Line data={attendanceTrend} />
          </Card>

          {/* Gender Ratio */}
          <Card>
            <h2 className="text-xl font-semibold mb-4">Gender Ratio</h2>
            <Doughnut data={genderData} />
          </Card>
        </div>

        {/* Summary */}
        <Card className="p-6">
          <h2 className="text-xl font-semibold mb-4">Summary</h2>

          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>IT has the highest attendance at 95%.</li>
            <li>HR department applied most leaves this quarter.</li>
            <li>Male-to-Female ratio is balanced at 60/40.</li>
            <li>Overall productivity improved by 4% this month.</li>
          </ul>
        </Card>
      </div>
    </HrLayout>
  );
}
